import axios, { type AxiosInstance } from 'axios';

const COMMERCE_GATEWAY_BASE_URL = '/api/commerce-gateway';

/**
 * Auth and X-Client-ID headers are attached server-side by the
 * /api/commerce-gateway proxy route. The client never sees the gateway token.
 */
export const createCommerceAxiosClient = (): AxiosInstance =>
  axios.create({
    baseURL: COMMERCE_GATEWAY_BASE_URL,
    headers: { 'Content-Type': 'application/json' },
  });

export const commerceAxiosClient = createCommerceAxiosClient();
